module.exports = __webpack_public_path__ + "static/06-5b417214deac66e5c7ed317c54110529.png";